<div class="cards-container container-fluid">
    <div class="row g-3">
        <div class="col-sm-12">
            <h1>Données techniques</h1>
        </div>
        <div class="col-sm-6 col-lg-2">
            <kpi-card
                [isLoading]="!accessRight"
                title="Statut"
                [body]="{ value: accessRight?.status }"
                descriptionContent="Etat de la connexion avec GRDF"
                cardClass="h-100"></kpi-card>
        </div>
        <div class="col-sm-6 col-lg-2">
            <kpi-card
                [isLoading]="!technicalData"
                [descriptionContent]="grdfTechnicalDataDefinition.code_calibre"
                title="Code calibre"
                [body]="{ value: technicalData?.code_calibre }"
                cardClass="h-100"></kpi-card>
        </div>

        <div class="col-sm-6 col-lg-2">
            <kpi-card
                [isLoading]="!technicalData"
                title="Fréquence"
                [body]="{ value: technicalData?.frequence }"
                [descriptionContent]="grdfTechnicalDataDefinition.frequence"
                [footer]="{ value: ' ' }"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [isLoading]="!technicalData"
                title="Code débit"
                [body]="{ value: toNumber(technicalData?.code_debit), suffix: ' m3/h' }"
                [descriptionContent]="grdfTechnicalDataDefinition.code_debit_normalise"
                [footer]="{
                    prefix: 'Normalisé: ',
                    value: toNumber(technicalData?.code_debit_normalise),
                    suffix: ' Nm3/h',
                }"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [isLoading]="!technicalData"
                title="Pression de livraison"
                [body]="{ value: toNumber(technicalData?.pression_livraison), suffix: ' bar' }"
                [descriptionContent]="grdfTechnicalDataDefinition.pression_livraison"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-2">
            <kpi-card
                [isLoading]="!technicalData"
                title="Matricule compteur"
                [body]="{ value: technicalData?.matricule_compteur }"
                [descriptionContent]="grdfTechnicalDataDefinition.matricule_compteur"
                [footer]="{ value: '' }"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [isLoading]="!technicalData"
                title=" Point d'Interface Transport Distribution (PTID)"
                [body]="{ value: technicalData?.libelle_pitd }"
                [footer]="{ prefix: 'Identifiant :', value: technicalData?.identifiant_pitd }"
                [descriptionContent]="grdfTechnicalDataDefinition.libelle_pitd"
                ardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-5" *ngIf="technicalData?.client_sensible_mig">
            <kpi-card
                [isLoading]="!technicalData"
                title="Client sensible MIG"
                [body]="{ value: technicalData?.client_sensible_mig }"
                [descriptionContent]="grdfTechnicalDataDefinition.client_sensible_mig"
                [footer]="{ value: '' }"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-7" *ngIf="technicalData?.regime_propriete_compteur">
            <kpi-card
                [isLoading]="!technicalData"
                title="Régime de propriété du compteur"
                [body]="{ value: technicalData?.regime_propriete_compteur }"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-7" *ngIf="technicalData?.regime_propriete_convertisseur">
            <kpi-card
                [isLoading]="!technicalData"
                title="Régime de propriété du convertisseur"
                [body]="{ value: technicalData?.regime_propriete_convertisseur }"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-7" *ngIf="technicalData?.regime_propriete_enregistreur">
            <kpi-card
                [isLoading]="!technicalData"
                title="Régime de propriété de l'enregistreur"
                [body]="{ value: technicalData?.regime_propriete_enregistreur }"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-7" *ngIf="technicalData?.regime_propriete_poste">
            <kpi-card
                [isLoading]="!technicalData"
                title="Régime de propriété du poste"
                [body]="{ value: technicalData?.regime_propriete_poste }"
                cardClass="h-100">
            </kpi-card>
        </div>
    </div>
    <br />
    <div class="row g-3">
        <div class="col-sm-12">
            <h1>Données Contractuelles</h1>
        </div>
        <div class="col-sm-6 col-lg-2">
            <kpi-card
                [isLoading]="!contractualData"
                title="Jour de publication :"
                [body]="{ value: contractualData?.date_publication?.toLocaleDateString() }"
                [descriptionContent]="grdfContractualDataDefinition.date_publication"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-2">
            <kpi-card
                [isLoading]="!contractualData"
                title="Mise en service :"
                [body]="{ value: contractualData?.date_mes?.toLocaleDateString() }"
                [descriptionContent]="grdfContractualDataDefinition.date_mes"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-2">
            <kpi-card
                [isLoading]="!contractualData"
                title="Tarif d'acheminement"
                [body]="{ value: contractualData?.tarif_acheminement }"
                [footer]="{
                    value: getFooterTarifAcheminement(contractualData?.tarif_acheminement),
                }"
                [descriptionContent]="grdfContractualDataDefinition.tarif_acheminement"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-3">
            <kpi-card
                [isLoading]="!contractualData"
                title="Consommation annuelle de référence (CAR)"
                [body]="{
                    value: toNumber(contractualData?.car_actuelle),
                    precision: 0,
                    suffix: ' kWh',
                }"
                [footer]="{
                    prefix: 'Future: ',
                    value: toNumber(contractualData?.car_future),
                    precision: 0,
                    suffix: ' kWh',
                }"
                [descriptionContent]="grdfContractualDataDefinition.car_description"
                [descriptionTitle]="grdfContractualDataDefinition.car_title"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-3" *ngIf="contractualData?.cja">
            <kpi-card
                [isLoading]="!contractualData"
                title="CJA"
                [body]="{ value: contractualData?.cja }"
                [descriptionContent]="grdfContractualDataDefinition.cja_description"
                [descriptionTitle]="grdfContractualDataDefinition.cja_title"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div
            class="col-sm-6 col-lg-2"
            *ngIf="contractualData?.cja_journaliere && contractualData?.cja_mensuelle">
            <kpi-card
                [isLoading]="!contractualData"
                title="CJA"
                [body]="{ prefix: 'Journalière: ', value: contractualData?.cja_journaliere }"
                [footer]="{ prefix: 'Mensuelle: ', value: contractualData?.cja_mensuelle }"
                [descriptionContent]="grdfContractualDataDefinition.cja_journaliere_mensuelle"
                cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-6" *ngIf="contractualData?.consommation_journaliere_plafond">
            <kpi-card
                [isLoading]="!contractualData"
                title="Consommation journalière plafond"
                [body]="{ value: contractualData?.consommation_journaliere_plafond }"
                [descriptionContent]="
                    grdfContractualDataDefinition.consommation_journaliere_plafond
                "
                cardClass="h-100">
            </kpi-card>
        </div>

        <div
            class="col-sm-6 col-lg-3"
            *ngIf="
                contractualData?.date_debut_profil_type_actuel &&
                contractualData?.date_fin_profil_type_actuel
            ">
            <kpi-card
                [isLoading]="!contractualData"
                title="Profil type actuel"
                [body]="{ value: contractualData?.profil_type_actuel }"
                [footer]="{
                    value:
                        contractualData?.date_debut_profil_type_actuel?.toLocaleDateString() +
                        ' - ' +
                        contractualData?.date_fin_profil_type_actuel?.toLocaleDateString(),
                }"
                [badge]="{
                    prefix: 'Futur: ',
                    value: contractualData?.profil_type_futur,
                    style: 'info',
                }"
                [descriptionContent]="grdfContractualDataDefinition.profil_type_actuel">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-2" *ngIf="contractualData?.modulation_n_1">
            <kpi-card
                [isLoading]="!contractualData"
                title="Modulation année N-1"
                [body]="{ value: contractualData?.modulation_n_1 }"
                [descriptionContent]="grdfContractualDataDefinition.modulation_n_1"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-2" *ngIf="contractualData?.modulation_n_2">
            <kpi-card
                [isLoading]="!contractualData"
                title="Modulation année N-2"
                [body]="{ value: contractualData?.modulation_n_2 }"
                [descriptionContent]="grdfContractualDataDefinition.modulation_n_2"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-2" *ngIf="contractualData?.modulation_n_3">
            <kpi-card
                [isLoading]="!contractualData"
                title="Modulation année N-3"
                [body]="{ value: contractualData?.modulation_n_3 }"
                [descriptionContent]="grdfContractualDataDefinition.modulation_n_3"
                cardClass="h-100">
            </kpi-card>
        </div>
        <div class="col-sm-6 col-lg-2" *ngIf="contractualData?.modulation_assiette">
            <kpi-card
                [isLoading]="!contractualData"
                title="Assiette de compensation de stockage"
                [body]="{ value: contractualData?.modulation_assiette }"
                [descriptionContent]="grdfContractualDataDefinition.modulation_assiette"
                [footer]="{ value: 'Moyenne des 2 modulation plus petite' }"
                cardClass="h-100">
            </kpi-card>
        </div>
    </div>
    <br />
    <div class="row g-3">
        <div class="col-sm-12">
            <h1>Localisation</h1>
        </div>
    </div>
    <div class="row g-3">
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="adresse">Adresse</label>
                <div class="row g-1">
                    <div class="col-sm-2">
                        <ed-textfield
                            innerId="adresse"
                            type="text"
                            [disabled]="true"
                            [ngModel]="technicalData?.numero_rue"></ed-textfield>
                    </div>
                    <div class="col-sm-10">
                        <ed-textfield
                            innerId="adresse"
                            type="text"
                            [disabled]="true"
                            [ngModel]="technicalData?.nom_rue"></ed-textfield>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="detail">Détails</label>
                <ed-textfield
                    innerId="detail"
                    type="text"
                    [disabled]="true"
                    [ngModel]="technicalData?.complement_adresse"></ed-textfield>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="cp">Commune</label>
                <div class="row g-1">
                    <div class="col-sm-4">
                        <ed-textfield
                            innerId="cp"
                            type="text"
                            [disabled]="true"
                            [ngModel]="technicalData?.code_postal"></ed-textfield>
                    </div>
                    <div class="col-sm-8">
                        <ed-textfield
                            innerId="ci"
                            type="text"
                            [disabled]="true"
                            [ngModel]="technicalData?.commune"></ed-textfield>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12">
            <geo-map-card
                title="Localisation"
                descriptionContent="Localisation approximative du point"
                descriptionTitle="Localisation"
                [geometries]="geometries ?? []"
                [isLoading]="geometries?.length == 0"
                [error]="!geometries"
                [getStyle]="getMapStyle"
                [legendConfig]="legendConfig"
                [mapId]="'locPRM'"
                [getTooltip]="getTooltip"></geo-map-card>
        </div>
    </div>

    <br />
    <div class="row g-3">
        <div class="col-sm-12">
            <h1>Droit d'accès</h1>
        </div>
    </div>
    <div class="row g-3">
        <div class="col-sm-6" *ngIf="accessRight?.clientName">
            <div class="panel-row">
                <label for="clientName">Nom du client</label>
                <ed-textfield
                    innerId="clientName"
                    type="text"
                    [disabled]="true"
                    [ngModel]="accessRight?.clientName">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-6" *ngIf="accessRight?.clientSirenSiret">
            <div class="panel-row">
                <label for="clientSirenSiret">SIRET du client</label>
                <ed-textfield
                    innerId="clientSirenSiret"
                    type="text"
                    [disabled]="true"
                    [ngModel]="accessRight?.clientSirenSiret">
                </ed-textfield>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="panel-row">
                <label for="clientRepresentativeName">Nom du représentant légal</label>
                <ed-textfield
                    innerId="clientRepresentativeName"
                    type="text"
                    [disabled]="true"
                    [ngModel]="accessRight?.clientRepresentativeName">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="clientRepresentativePhone">Téléphone du représentant légal</label>
                <ed-textfield
                    innerId="clientRepresentativePhone"
                    type="text"
                    [disabled]="true"
                    [ngModel]="accessRight?.clientRepresentativePhoneNumber">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-12">
            <div class="panel-row">
                <label for="clientRepresentativeEmail">Email du représentant légal</label>
                <ed-textfield
                    innerId="clientRepresentativeEmail"
                    type="text"
                    [disabled]="true"
                    [ngModel]="accessRight?.clientRepresentativeEmail">
                </ed-textfield>
            </div>
        </div>

        <div class="col-sm-4">
            <div class="panel-row">
                <label for="createdAt">Créé le</label>
                <ed-textfield
                    innerId="createdAt"
                    type="text"
                    [disabled]="true"
                    [ngModel]="accessRight?.consentStart">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="panel-row">
                <label for="validationDate">Actif depuis le</label>
                <ed-textfield
                    innerId="validationDate"
                    type="text"
                    [disabled]="true"
                    [ngModel]="accessRight?.validationDate">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-4" *ngIf="accessRight?.disabledAt">
            <div class="panel-row">
                <label for="disabledAt">Désactivé le</label>
                <ed-textfield
                    innerId="disabledAt"
                    type="text"
                    [disabled]="true"
                    [ngModel]="accessRight?.disabledAt">
                </ed-textfield>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="accessRight?.errorAt">
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="errorAt">Date de l'erreur</label>
                <ed-textfield
                    innerId="errorAt"
                    type="text"
                    [disabled]="true"
                    [ngModel]="accessRight?.errorAt">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="errorMessage">Message d'erreur</label>
                <ed-textfield
                    innerId="errorMessage"
                    type="text"
                    [disabled]="true"
                    [ngModel]="accessRight?.errorMessage">
                </ed-textfield>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-5">
            <div class="panel-row">
                <label for="proofFile">Preuve de consentement : {{ accessRight?.proofType }}</label>

                <ed-button
                    class="left px-1"
                    [colorSchema]="buttonColorsPrimary"
                    [icon]="'icon-download-cloud-02'"
                    (click)="downloadProofFile('userToConsumer')"
                    >Télécharger la preuve de consentement entre le titulaire et vous</ed-button>
       
                <div class="row g-2" *ngIf="loggedUser?.isAdmin && accessRight?.proofType=='FILE'">
                    <div class="col-sm-6">
                        <div class="panel-row">
                            <label for="proofFile">Remplacer la preuve (Administrateur uniquement)</label>
                            <ed-input-file
                                innerId="fileProof"
                                [allowedFormat]="['PDF', 'PNG', 'JPG', 'JPEG']"
                                (onSubmit)="onFileUpload($event)"></ed-input-file>
                        </div>
                    </div>
                </div>
                <ed-button
                    class="left px-1"
                    [colorSchema]="buttonColorsPrimary"
                    [icon]="'icon-download-cloud-02'"
                    (click)="downloadProofFile('userToThirdParty')"
                    >Télécharger la preuve de consentement entre Vous et consometer</ed-button>
            </div>
        </div>
    </div>

</div>
